@if (isTemplatePrint() || visibleNotes().length > 0) {
  <div class="medical-notes-print-section">
    <div class="medical-notes-print-header">
      <div class="header">
        <div class="title">
          <div class="title-text">Medical Notes</div>
        </div>
        <span class="message">* populated from PatientNow</span>
      </div>
      <hr class="divider" />
    </div>

    <div class="medical-notes-print-table">
      <fb-simple-table [data]="visibleNotes()">
        <ng-container fbSimpleTableColumnDef>
          <ng-template fbSimpleTableHeaderCellDef>Date</ng-template>
          <ng-template fbSimpleTableCellDef let-note>{{ note.date | date: 'MM/dd/yyyy' }}</ng-template>
        </ng-container>
        <ng-container fbSimpleTableColumnDef>
          <ng-template fbSimpleTableHeaderCellDef>Employee</ng-template>
          <ng-template fbSimpleTableCellDef let-note>{{ note.employeeName || note.employeeId }}</ng-template>
        </ng-container>
        <ng-container fbSimpleTableColumnDef>
          <ng-template fbSimpleTableHeaderCellDef>Medical Note</ng-template>
          <ng-template fbSimpleTableCellDef let-note>
            <span class="medical-note-cell">
              <span>{{ note.text }}</span>
              <fb-scribe-suggestion-indicator [target]="note" variant="compact"></fb-scribe-suggestion-indicator>
            </span>
          </ng-template>
        </ng-container>
      </fb-simple-table>
    </div>
  </div>
}
